<template>
  <!-- Mobile -->
  <div class="timeline-container-mobile mx-3 d-block d-lg-none">
    <div class="eurostar-hero-mobile mb-3">
      <div class="eurostar-logo d-flex align-items-center gap-2 mb-2">
        <span class="eurostar-logo-box">
          <EurostarSvgIcon :width="18" :height="18" color="#ffffff" />
        </span>
        <span class="eurostar-logo-text">eurostar</span>
      </div>
      <h2 class="timeline-title-mobile heading text-white mb-3">
        <strong>{{ t('planning_eurostar_headline_bold', 'Get from London to the French Alps') }}</strong>
        <span class="d-block fw-normal">{{ t('planning_eurostar_headline_regular', 'on Saturdays and return Sundays.') }}</span>
      </h2>
      <div class="eurostar-pill">
        <svg width="16" height="16" class="icon"><use xlink:href="#___icon___home"></use></svg>
        {{ t('planning_eurostar_nights_resort', '7 nights in resort') }}
        <span>+</span>
        <svg width="16" height="16" class="icon"><use xlink:href="#___icon___night"></use></svg>
        {{ t('planning_eurostar_night_station', '1 night near station') }}
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-ring-blue"></div>
        <div class="timeline-line-mobile line-blue-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-blue">
          {{ t('planning_eurostar_morning', 'Morning') }} <strong>{{ t('planning_eurostar_departure', 'Departure') }}</strong>
          <span class="timeline-detail-mobile">{{ originLabel }} → {{ alpineStationLabel }}</span>
        </div>
        <div class="custom-badge-mobile badge-train-mobile">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
          {{ t('planning_eurostar_saturday', 'Saturday') }}
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-ring-orange"></div>
        <div class="timeline-line-mobile line-orange-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-blue">
          {{ t('planning_eurostar_evening', 'Evening') }} <strong>{{ t('planning_eurostar_arrival', 'Arrival') }}</strong>
          <span class="timeline-detail-mobile">{{ t('planning_eurostar_transfer_resort', 'Transfert to resort') }}</span>
        </div>
        <div class="custom-badge-mobile badge-stay-orange-mobile">
          <SkiSvgIcon color="#f56600" :width="16" :height="16" fill="#f56600" stroke="#f56600" />
          {{ t('planning_eurostar_7days', '7 days') }}
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-fill-orange"></div>
        <div class="timeline-line-mobile line-orange-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-orange">
          {{ t('planning_eurostar_7days', '7 days') }} <strong>{{ t('planning_eurostar_enjoy', 'Enjoy your holiday') }}</strong>
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-ring-grey"></div>
        <div class="timeline-line-mobile line-lightgrey-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-grey">
          {{ t('planning_eurostar_afterski', 'After skiing') }} <strong>{{ t('planning_eurostar_after_skiing_short', 'Transfer') }}</strong>
          <span class="timeline-detail-mobile">{{ t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station') }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-fill-grey"></div>
        <div class="timeline-line-mobile line-lightgrey-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-grey">
          {{ t('planning_eurostar_night', 'Night') }} <strong>{{ t('planning_eurostar_night_stay', '1 night stay') }}</strong>
          <span class="timeline-detail-mobile">{{ t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station") }}</span>
        </div>
        <div class="custom-badge-mobile badge-night-mobile">
          <svg width="16" height="16" class="icon"><use xlink:href="#___icon___night"></use></svg>
          {{ t('planning_eurostar_saturday', 'Saturday') }}
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-ring-blue"></div>
        <div class="timeline-line-mobile line-blue-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile label-blue">
          {{ t('planning_eurostar_morning', 'Morning') }} <strong>{{ t('planning_eurostar_departure', 'Departure') }}</strong>
          <span class="timeline-detail-mobile">{{ alpineStationLabel }} → {{ originLabel }}</span>
        </div>
        <div class="custom-badge-mobile badge-train-mobile">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
          {{ t('planning_eurostar_sunday', 'Sunday') }}
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile point-ring-blue"></div>
      </div>
      <div class="timeline-content-mobile">
        <div class="timeline-text-mobile label-blue mb-0">
          {{ t('planning_eurostar_evening', 'Evening') }} <strong>{{ t('planning_eurostar_arrival', 'Arrival') }}</strong>
          <span class="timeline-detail-mobile">{{ arrivalOriginLabel }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Desktop -->
  <div class="timeline-section d-none d-lg-flex">
    <div class="eurostar-hero">
      <div class="eurostar-logo d-flex align-items-center gap-2">
        <span class="eurostar-logo-box">
          <EurostarSvgIcon :width="18" :height="18" color="#ffffff" />
        </span>
        <span class="eurostar-logo-text">eurostar</span>
      </div>
      <div class="eurostar-headline">
        <strong>{{ t('planning_eurostar_headline_bold', 'Get from London to the French Alps') }}</strong>
        <span class="d-block">{{ t('planning_eurostar_headline_regular', 'on Saturdays and return Sundays.') }}</span>
      </div>
      <div class="eurostar-pill">
        <svg width="16" height="16" class="icon"><use xlink:href="#___icon___home"></use></svg>
        {{ t('planning_eurostar_nights_resort', '7 nights in resort') }}
        <span>+</span>
        <svg width="16" height="16" class="icon"><use xlink:href="#___icon___night"></use></svg>
        {{ t('planning_eurostar_night_station', '1 night near station') }}
      </div>
    </div>

    <div class="timeline-track-wrap">
      <div class="timeline-track">

        <!-- Flags row -->
        <div class="flag flag-blue flag-seg-1">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
          {{ t('planning_eurostar_saturday', 'Saturday') }}
        </div>
        <div class="flag flag-orange flag-point-3">
          <SkiSvgIcon color="#f56600" :width="16" :height="16" fill="#f56600" stroke="#f56600" />
          {{ t('planning_eurostar_7days', '7 days') }}
        </div>
        <div class="flag flag-grey flag-point-5">
          <svg width="15" height="15" class="icon"><use xlink:href="#___icon___night"></use></svg>
          {{ t('planning_eurostar_saturday', 'Saturday') }}
        </div>
        <div class="flag flag-blue flag-seg-6">
          <TrainSvgIcon color="var(--primary-blue)" :width="16" :height="16" fill="var(--primary-blue)" stroke="var(--primary-blue)" />
          {{ t('planning_eurostar_sunday', 'Sunday') }}
        </div>

        <!-- Line row: half segments around each dot keep the line continuous -->
        <div class="line-cell tlc-1">
          <span class="half half-none"></span>
          <span class="dot dot-ring-blue"></span>
          <span class="half half-blue"></span>
        </div>
        <div class="line-cell tlc-2">
          <span class="half half-blue"></span>
          <span class="dot dot-ring-orange"></span>
          <span class="half half-orange"></span>
        </div>
        <div class="line-cell tlc-3">
          <span class="half half-orange"></span>
          <span class="dot dot-fill-orange"></span>
          <span class="half half-orange"></span>
        </div>
        <div class="line-cell tlc-4">
          <span class="half half-orange"></span>
          <span class="dot dot-ring-grey"></span>
          <span class="half half-lightgrey"></span>
        </div>
        <div class="line-cell tlc-5">
          <span class="half half-lightgrey"></span>
          <span class="dot dot-fill-grey"></span>
          <span class="half half-lightgrey"></span>
        </div>
        <div class="line-cell tlc-6">
          <span class="half half-lightgrey"></span>
          <span class="dot dot-ring-blue"></span>
          <span class="half half-blue"></span>
        </div>
        <div class="line-cell tlc-7">
          <span class="half half-blue"></span>
          <span class="dot dot-ring-blue"></span>
          <span class="half half-none"></span>
        </div>

        <!-- Labels row -->
        <div class="label-cell label-blue tlc-1">
          <span class="label-head">
            {{ t('planning_eurostar_morning', 'Morning') }}<strong>{{ t('planning_eurostar_departure', 'Departure') }}</strong>
          </span>
          <span class="label-detail">{{ originLabel }} → {{ alpineStationLabel }}</span>
        </div>
        <div class="label-cell label-blue tlc-2">
          <span class="label-head">
            {{ t('planning_eurostar_evening', 'Evening') }}<strong>{{ t('planning_eurostar_arrival', 'Arrival') }}</strong>
          </span>
          <span class="label-detail">{{ t('planning_eurostar_transfer_resort', 'Transfert to resort') }}</span>
        </div>
        <div class="label-cell label-orange tlc-3">
          <span class="label-head">
            {{ t('planning_eurostar_7days', '7 days') }}<strong>{{ t('planning_eurostar_enjoy', 'Enjoy your holiday') }}</strong>
          </span>
        </div>
        <div class="label-cell label-grey tlc-4">
          <span class="label-head">
            {{ t('planning_eurostar_afterski', 'After skiing') }}<strong>{{ t('planning_eurostar_after_skiing_short', 'Transfer') }}</strong>
          </span>
          <span class="label-detail">{{ t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station') }}</span>
        </div>
        <div class="label-cell label-grey tlc-5">
          <span class="label-head">
            {{ t('planning_eurostar_night', 'Night') }}<strong>{{ t('planning_eurostar_night_stay', '1 night stay') }}</strong>
          </span>
          <span class="label-detail">{{ t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station") }}</span>
        </div>
        <div class="label-cell label-blue tlc-6">
          <span class="label-head">
            {{ t('planning_eurostar_morning', 'Morning') }}<strong>{{ t('planning_eurostar_departure', 'Departure') }}</strong>
          </span>
          <span class="label-detail">{{ alpineStationLabel }} → {{ originLabel }}</span>
        </div>
        <div class="label-cell label-blue tlc-7">
          <span class="label-head">
            {{ t('planning_eurostar_evening', 'Evening') }}<strong>{{ t('planning_eurostar_arrival', 'Arrival') }}</strong>
          </span>
          <span class="label-detail">{{ arrivalOriginLabel }}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

import TrainSvgIcon from "./svg/trainSvgIcon.vue"
import SkiSvgIcon from "./svg/skiSvgIcon.vue"
import EurostarSvgIcon from "./svg/eurostarSvgIcon.vue"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"

const store = useStore()
const content = computed(() => store.state.content || {})

const t = (key: string, fallback: string) => content.value[key] || fallback

const originCode = computed(() => store.state.flightOrigin?.split("-")[0] || "")

const originLabel = computed(() => {
	const code = originCode.value
	if (!code) return t("planning_eurostar_outbound_from", "London St Pancras")

	const fromContent = content.value["planning_traintimeline_station"]?.[code]
	return (
		fromContent?.name ||
		fromContent?.short ||
		trainStationCodeMap.get(code)?.name ||
		t("planning_eurostar_outbound_from", "London St Pancras")
	)
})

const alpineStationLabel = computed(() =>
	t("planning_eurostar_station", "Station")
)

const arrivalOriginLabel = computed(() => {
	const arrivalTemplate = t("planning_eurostar_arrival_london", "Arrival {origin}")
	if (arrivalTemplate.includes("{origin}")) {
		return arrivalTemplate.replace("{origin}", originLabel.value)
	}
	// Legacy CMS copy like "Arrival London St Pancras" → keep prefix, use selected origin
	if (arrivalTemplate.toLowerCase().startsWith("arrival")) {
		return `${t("planning_eurostar_arrival", "Arrival")} ${originLabel.value}`
	}
	return `${t("planning_eurostar_arrival", "Arrival")} ${originLabel.value}`
})
</script>

<style scoped>
.timeline-container-mobile,
.timeline-section {
  --eurostar-orange: #f56600;
  --eurostar-grey: #6d6e71;
  --eurostar-grey-dark: #585d63;
  --eurostar-grey-light: #d2d4d9;
}

/* ---------- Shared hero pieces ---------- */
.eurostar-logo-box {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: var(--primary-blue);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.eurostar-logo-text {
  font-size: 1rem;
  font-weight: 400;
}

.eurostar-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: var(--primary-white);
  color: var(--primary-blue);
  border-radius: 50rem;
  padding: 6px 12px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  align-self: flex-start;
}

/* ---------- Mobile ---------- */
.timeline-container-mobile {
  background-color: var(--primary-white);
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(13, 38, 76, 0.12);
  padding: 30px 20px;
  max-width: 450px;
  margin: 20px auto;
}

.eurostar-hero-mobile {
  background: var(--primary-blue);
  color: var(--primary-white);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.timeline-title-mobile {
  font-size: 1.25rem;
  color: var(--primary-white);
  letter-spacing: -0.3px;
  line-height: 1.3;
}

.timeline-visual-mobile {
  min-width: 24px;
}

.timeline-point-mobile {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2.5px solid var(--primary-blue);
  background-color: var(--primary-white);
  flex-shrink: 0;
  margin-top: 4px;
}

.point-ring-blue { border-color: var(--primary-blue); }
.point-ring-orange { border-color: var(--eurostar-orange); }
.point-ring-grey { border-color: var(--eurostar-grey-dark); }
.point-fill-orange {
  border-color: var(--eurostar-orange);
  background-color: var(--eurostar-orange);
}
.point-fill-grey {
  border-color: var(--eurostar-grey-dark);
  background-color: var(--eurostar-grey-dark);
}

.timeline-line-mobile {
  width: 2px;
  margin-top: 4px;
  margin-bottom: -16px;
}

.line-blue-mobile { background-color: var(--primary-blue); }
.line-orange-mobile { background-color: var(--eurostar-orange); }
.line-lightgrey-mobile { background-color: var(--eurostar-grey-light); }

.timeline-text-mobile {
  font-size: 0.95rem;
  line-height: 1.4;
  margin-bottom: 10px;
}

.timeline-text-mobile.label-blue { color: var(--primary-blue); }
.timeline-text-mobile.label-orange { color: var(--eurostar-orange); }
.timeline-text-mobile.label-grey { color: var(--eurostar-grey); }

.timeline-detail-mobile {
  display: block;
  font-size: 0.8rem;
  color: #3f4247;
  margin-top: 2px;
}

.custom-badge-mobile {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px;
  border-radius: 50rem;
  font-size: 0.85rem;
  font-weight: 700;
  margin-bottom: 6px;
}

.badge-train-mobile {
  background-color: #eef3fb;
  color: var(--primary-blue);
}

.badge-stay-orange-mobile {
  background-color: #fdf0e5;
  color: var(--eurostar-orange);
}

.badge-night-mobile {
  background-color: #ececec;
  color: var(--eurostar-grey);
}

/* ---------- Desktop ---------- */
@media only screen and (min-width: 960px) {
  .timeline-section {
    background-color: var(--primary-white);
    border-radius: 16px;
    box-shadow: 0 8px 20px rgba(13, 38, 76, 0.12);
    overflow: hidden;
  }

  .eurostar-hero {
    flex: 0 0 32%;
    max-width: 350px;
    background: var(--primary-blue);
    color: var(--primary-white);
    padding: 18px 42px 18px 20px;
    clip-path: polygon(0 0, calc(100% - 34px) 0, 100% 100%, 0 100%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
  }

  .eurostar-headline {
    font-size: 0.95rem;
    line-height: 1.35;
  }

  .timeline-track-wrap {
    flex: 1;
    min-width: 0;
    padding: 18px 28px 14px 12px;
    display: flex;
    align-items: center;
  }

  .timeline-track {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    grid-template-rows: auto 14px auto;
    width: 100%;
  }

  .tlc-1 { grid-column: 1; }
  .tlc-2 { grid-column: 2; }
  .tlc-3 { grid-column: 3; }
  .tlc-4 { grid-column: 4; }
  .tlc-5 { grid-column: 5; }
  .tlc-6 { grid-column: 6; }
  .tlc-7 { grid-column: 7; }

  /* Flags row: centered over a segment (spans two columns) or a dot (one column) */
  .flag {
    grid-row: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    align-self: end;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
  }

  .flag-seg-1 { grid-column: 1 / 3; }
  .flag-point-3 { grid-column: 3; }
  .flag-point-5 { grid-column: 5; }
  .flag-seg-6 { grid-column: 6 / 8; }

  .flag-blue { color: var(--primary-blue); }
  .flag-orange { color: var(--eurostar-orange); }
  .flag-grey { color: var(--eurostar-grey); }

  /* Line row */
  .line-cell {
    grid-row: 2;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .half {
    flex: 1;
    height: 2px;
  }

  .half-none { background: transparent; }
  .half-blue { background: var(--primary-blue); }
  .half-orange { background: var(--eurostar-orange); }
  .half-lightgrey { background: var(--eurostar-grey-light); }

  .dot {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: 2.5px solid;
    background: var(--primary-white);
    flex-shrink: 0;
  }

  .dot-ring-blue { border-color: var(--primary-blue); }
  .dot-ring-orange { border-color: var(--eurostar-orange); }
  .dot-ring-grey { border-color: var(--eurostar-grey-dark); }
  .dot-fill-orange {
    border-color: var(--eurostar-orange);
    background: var(--eurostar-orange);
  }
  .dot-fill-grey {
    border-color: var(--eurostar-grey-dark);
    background: var(--eurostar-grey-dark);
  }

  /* Labels row */
  .label-cell {
    grid-row: 3;
    align-self: start;
    padding: 12px 6px 0;
    text-align: center;
    line-height: 1.3;
  }

  .label-head {
    display: block;
    font-size: 12px;
    font-weight: 400;
  }

  .label-head strong {
    display: block;
    font-size: 13px;
  }

  .label-blue .label-head { color: var(--primary-blue); }
  .label-orange .label-head { color: var(--eurostar-orange); }
  .label-grey .label-head { color: var(--eurostar-grey); }

  .label-detail {
    display: block;
    margin-top: 6px;
    font-size: 11px;
    color: #3f4247;
  }
}
</style>
